import { useCallback, useState } from 'react';

import { get } from '../../../../../redux/api';
import { nuc } from '../../../../../utils';

/**
 * Simple hook for managing the "reanalyze dependency"
 * request and button state.
 * @deprecated Use @app/hooks/api/revisions/useRebuildRevision.ts instead.
 */
const useRebuildRevision = (revisionLocator: string) => {
  const [hasRebuilt, setHasRebuilt] = useState(false);

  const onRebuild = useCallback(async () => {
    try {
      if (revisionLocator) {
        await get(`/api/revisions/${nuc(revisionLocator)}/rebuild`);
        setHasRebuilt(true);
      }
    } catch (_error) {
      //  Note that we don't care about handling the error here,
      //  as there isn't really a point. If this request fails,
      //  the user can simply retry it.
    }
  }, [revisionLocator]);

  return {
    hasRebuilt,
    onRebuild,
  };
};

export default useRebuildRevision;
